import arrayReduce from './arrayReduce';

export default function extractPassThroughProps(passThrough, ruleProps) {
  return arrayReduce(passThrough, function (output, property) {
    output[property] = ruleProps[property];
    return output;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela/node_modules/fela-utils/es/extractPassThroughProps.js
// module id = 684
// module chunks = 0